import { render, staticRenderFns } from "./ChurchService.vue?vue&type=template&id=2f8ee36f&"
import script from "./ChurchService.vue?vue&type=script&lang=js&"
export * from "./ChurchService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports